import { isCancel } from 'axios';
import { createCacheWrapper } from '@utils/cache';
import { DAYS_TO_MS, HOURS_TO_MS } from '@utils/constants';
import { sitecoreAxios } from './core.axios.js';
import { buildUrl } from './util.build-url.js';
import { parseAspectRatio } from './util.parse-aspect-ratio.js';

const cache = createCacheWrapper({
  timeToLiveMs: 1 * HOURS_TO_MS,
  evictAfterMs: 1 * DAYS_TO_MS,
  capacity: 500
});
function getSearchResults(portalId, query, options) {
  const url = buildUrl(
    `/api/v1/portals/${portalId}/snippetsearch?query=${encodeURIComponent(
      query
    )}`,
    options
  );
  return cache(url, async () => {
    var _a;
    if (!query) {
      return [];
    }
    try {
      const response = await sitecoreAxios.get(url, {
        cancelToken: (_a = options == null ? void 0 : options.cancelToken) == null ? void 0 : _a.token
      });
      return (response.data ?? []).map((it) => {
        var _a2, _b, _c, _d;
        switch (it.template) {
          case "LibraryEntry":
            return {
              type: "library-element",
              id: it.id,
              path: it.itemPath,
              title: it.title,
              description: ((_b = (_a2 = it.snippets[0]) == null ? void 0 : _a2.texts[0]) == null ? void 0 : _b.texts[0]) ?? void 0,
              breadcrumbs: it.breadcrumb.map((it2) => ({
                id: it2.Id,
                path: it2.Path,
                title: it2.Title,
                type: it2.Type === "LibraryFolder" ? "library-folder" : "page"
              }))
            };
          default: {
            const vignetteAlt = (() => {
              const base = it.vignetteAltText;
              if (!base) {
                return void 0;
              }
              if (it.vignetteAltTextIsAiGenerated === "true") {
                return `${base} (AI-tekst, muligvis ukorrekt)`;
              } else {
                return base;
              }
            })();
            return {
              type: "page",
              id: it.id,
              path: it.itemPath,
              title: it.title,
              description: ((_d = (_c = it.snippets[0]) == null ? void 0 : _c.texts[0]) == null ? void 0 : _d.texts[0]) ?? void 0,
              vignette: it.vignetteUrl && it.vignetteAspectRatio ? {
                ...parseAspectRatio(it.vignetteAspectRatio),
                url: `${process.env["PM2_MEDIA_DOMAIN"]}${it.vignetteUrl}`,
                alt: vignetteAlt
              } : void 0,
              breadcrumbs: it.breadcrumb.map((it2) => ({
                id: it2.Id,
                path: it2.Path,
                title: it2.Title,
                type: it2.Type === "ChapterGroup" ? "label" : "page"
              }))
            };
          }
        }
      }).filter((it) => !!it.title || !!it.description);
    } catch (err) {
      if (!(options == null ? void 0 : options.retainOnError) || isCancel(err)) {
        throw err;
      }
      return [];
    }
  }).getStaleWhileRevalidate();
}

export { getSearchResults };
//# sourceMappingURL=request.get-search-results.js.map
